import { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import MediaTypes from '../../constants/MediaType';
import MediaBridgeContext from '../internal/MediaBridgeContext';
import oEmbedType from '../../constants/oEmbedType';
const AbstractPicker = ({
  providerId,
  mediaType,
  mediaTypes,
  oEmbedTypes,
  supportedOEmbedTypes,
  editingVideoId,
  assetType,
  returnFile,
  showNonEmbeddable,
  allowNonHlsVideoEmbeds,
  onClose,
  onSelect,
  onClickDetails
}) => {
  const {
    openPicker,
    unmountPicker
  } = useContext(MediaBridgeContext);
  useEffect(() => {
    openPicker({
      mediaType,
      mediaTypes,
      providerId,
      oEmbedTypes,
      supportedOEmbedTypes,
      editingVideoId,
      assetType,
      returnFile,
      showNonEmbeddable,
      allowNonHlsVideoEmbeds
    }, onSelect, onClose, onClickDetails);
    return () => {
      unmountPicker();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};
AbstractPicker.propTypes = {
  mediaType: PropTypes.oneOf(Object.values(MediaTypes)),
  mediaTypes: PropTypes.arrayOf(PropTypes.oneOf(Object.values(MediaTypes))),
  oEmbedTypes: PropTypes.arrayOf(PropTypes.oneOf(Object.values(oEmbedType))),
  supportedOEmbedTypes: PropTypes.arrayOf(PropTypes.oneOf(Object.values(oEmbedType))),
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};
export default AbstractPicker;